import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

export default function CardEditable({ title, children, bottomContent, onEdit, onDelete }) {
  return (
    <Box
      data-id="editable-card"
      py={1}
      px={2}
      border={1}
      display="flex"
      flexDirection="column"
      borderColor="divider"
      borderRadius={1}
      height="100%"
      boxSizing="border-box"
    >
      <Typography fontWeight={500} sx={{ pr: 5 }}>{title}</Typography>
      {children}
      <Box display="flex" justifyContent="space-between" alignItems="flex-end" mt="auto">
        <Box>{bottomContent}</Box>
        <Box display="flex" flexShrink={0} gap={0.5}>
          {onEdit && (
            <Tooltip title="Edit" arrow>
              <IconButton size="small" aria-label="edit" onClick={onEdit}>
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip title="Delete" arrow>
              <IconButton size="small" aria-label="delete" onClick={onDelete}>
                <DeleteOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </Box>
  );
}
